<script type="application/javascript">
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, { siteKey: '6Lf07pciAAAAAM-Ksg7rjTfoUee0fRAC-Au99uHN' });
export default {
    props: ['stripeKey'],
    data() {
        return {
            checkoutOpen: false,
            name: '',
            email: '',
            token: '',
            reCaptchaToken: '',
            price: '',
            errorMessage: '',
            busy: false,
            plan: null,
            infinityPlan: false,
            redirect_url: null,
            style: {
                base: {
                    iconColor: '#62647B',
                    color: '#1f2243',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    height: '34px',
                    fontFamily: 'sans-serif',
                    '::placeholder': {
                        color: '#ADAEBA',
                    },

                },
                invalid: {
                    iconColor: '#62647B',
                    color: '#1f2243',
                },
            },
            stripe: Stripe(this.stripeKey),
            card: null,
            clientSecret: null
        };
    },
    watch: {
        checkoutOpen() {
            if (this.checkoutOpen) {
                this.$nextTick(() => {
                    const elements = this.stripe.elements();
                    // Create an instance of the card element
                    const card = elements.create('card', { hidePostalCode: true });
                    // Mount the card element to the DOM element using the ref attribute
                    card.mount(this.$refs.cardElement);
                    // Handle real-time validation errors from the card Element.
                    card.addEventListener('change', event => {
                        const displayError = document.getElementById('card-errors');
                        if (event.error) {
                            displayError.textContent = event.error.message;
                        } else {
                            displayError.textContent = '';
                        }
                    });
                    this.card = card;
                });
            } else {
                this.plan = null;
                this.name = '';
                this.email = '';
                this.infinityPlan = false;
            }
        }
    },
    async mounted() {
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login".
        this.setCaptchaToken();
        setInterval(this.setCaptchaToken(), 2 * 60 * 1000);
    },
    methods: {
        async setCaptchaToken() {
            this.reCaptchaToken = await this.$recaptcha('login');
        },
        async createStripeToken() {
            const result = await this.stripe.createToken(this.card);
            if (result.error) {
                this.showStripeError(result.error.message);
                this.busy = false;
                return null;
            } else {
                return result.token.id;
            }
        },
        async submitForm() {
            if (this.busy) return;
            this.busy = true;

            const token = await this.createStripeToken();
            if (!token) return;

            this.token = token;
            this.infinityPlan ? this.purchaseInfinityPlan() : this.purchaseProgramPlan();
        },
        async purchaseInfinityPlan() {
            try {
                const response = await axios.post('/purchase', this.getPurchaseData());
                if (response.data.action_required.is_required) {
                    this.clientSecret = {
                        secret: response.data.action_required.client_secret,
                        res: response
                    };
                    await this.confirmPayment();
                    this.handleSuccessfulPlanPurchase(response);
                } else {
                    this.handleSuccessfulPlanPurchase(response);
                }
            } catch (err) {
                this.showStripeError(err.response.data.message);
            }
        },
        async handleSuccessfulPlanPurchase(response) {
            dataLayer.push({
                event: 'purchase',
                plan: 'plan3_pro_v9',
                price: 36,
                planType: 'monthly',
                section: 'program bundle',
            });
            this.redirect_url = response.data.redirect_url;
            // Generate new token for academy plan
            const newToken = await this.createStripeToken();
            if (!newToken) return;

            // Call submit with new token
            await this.purchaseProgramPlan(newToken);
        },
        async purchaseProgramPlan(newToken = null) {
            try {
                const token = newToken ? newToken : this.token;
                const response = await axios.post('/academy-purchase', this.getAcademyPurchaseData(token));

                this.handleSuccess(response);
            } catch (err) {
                this.showStripeError(err.response.data.message);
            }
        },

        handleSuccess(response) {
            this.busy = false;
            let intPrice = parseInt(this.plan.price.discountPrice.replace(',', ''), 10);
            /* globals dataLayer */
            dataLayer.push({
                event: 'ProgramPurchase',
                plan: this.plan.name,
                price: intPrice,
            });
            window.Intercom('boot', {
                app_id: 'ujmidnoy',
                email: this.email,
                program_purchase: true, // custom attribute (property)
                user_id: this.email,
                created_at: Math.round(new Date().getTime() / 1000),
            });
            this.$refs.modalLeft.style.display = 'none';
            // document.getElementById('example-1').style.display = 'none';
            document.getElementsByClassName('pre-purchase')[0].style.display = 'none';
            document.getElementsByClassName('after-purchase')[0].style.display = 'flex';
            if (response.data.redirect_url) {
                this.redirect_url = response.data.redirect_url;
            }
            // this.$refs.activatePlanBtn.setAttribute('href', this.redirect_url);
        },
        async confirmPayment() {
            const response = await this.stripe.confirmCardPayment(this.clientSecret.secret, {
                payment_method: { card: this.card }
            });
            if (response.error) {
                this.showStripeError(response.error.message);
            }
        },
        showStripeError(message) {
            const errorElement = document.getElementById('card-errors');
            errorElement.textContent = message;
            this.busy = false;
        },
        getPurchaseData() {
            return {
                name: this.name,
                email: this.email,
                deal: 'plan3_pro_v9',
                token: this.token,
                type: 'monthly',
                reCaptchaToken: this.reCaptchaToken
            };
        },
        getAcademyPurchaseData(token) {
            return {
                name: this.name,
                email: this.email,
                plan: this.plan.name,
                token: token,
            };
        },
    }

};

</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/AcademyCheckout.vue